var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-crud-page',{attrs:{"master":"sensor_type","title":"Sensor Type","access":"master_sensor_type","pk":"mstyId","columns":_vm.columns,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }